"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.CheckboxGroup = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

var React = _interopRequireWildcard(require("react"));

var _FormFieldWrapper = _interopRequireDefault(require("../FormFieldWrapper/FormFieldWrapper"));

var _FieldLabel = _interopRequireDefault(require("../../ui/FieldLabel"));

var _checkboxGroupConfig = require("./checkboxGroupConfig");

var _types = require("../../types");

var _validation = require("../../types/validation");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var InheritedFieldValidation = _flowRuntime["default"].tdz(function () {
  return _validation.InheritedFieldValidation;
});

var InputStyle = _flowRuntime["default"].tdz(function () {
  return _types.InputStyle;
});

var CheckboxGroupDefinition = _flowRuntime["default"].tdz(function () {
  return _checkboxGroupConfig.CheckboxGroupDefinition;
});

var Props = _flowRuntime["default"].type("Props", _flowRuntime["default"].object(_flowRuntime["default"].property("checkboxGroup", _flowRuntime["default"].ref(CheckboxGroupDefinition)), _flowRuntime["default"].property("disabled", _flowRuntime["default"]["boolean"](), true), _flowRuntime["default"].property("inheritedFieldValidation", _flowRuntime["default"].array(_flowRuntime["default"].ref(InheritedFieldValidation)), true), _flowRuntime["default"].property("onChange", _flowRuntime["default"]["function"](_flowRuntime["default"].param("_arg0", _flowRuntime["default"].any()), _flowRuntime["default"]["return"](_flowRuntime["default"].any())), true)));

var CheckboxGroupProps = _flowRuntime["default"].type("CheckboxGroupProps", _flowRuntime["default"].object(_flowRuntime["default"].property("checkboxGroup", _flowRuntime["default"].ref(CheckboxGroupDefinition)), _flowRuntime["default"].property("disabled", _flowRuntime["default"]["boolean"](), true), _flowRuntime["default"].property("input", _flowRuntime["default"].object()), _flowRuntime["default"].property("inputStyle", _flowRuntime["default"].ref(InputStyle)), _flowRuntime["default"].property("isRequired", _flowRuntime["default"]["boolean"]())));

var CheckboxGroup = function CheckboxGroup(_arg) {
  var checkboxGroup = _arg.checkboxGroup,
      disabled = _arg.disabled,
      input = _arg.input,
      inputStyle = _arg.inputStyle,
      isRequired = _arg.isRequired;

  var handleChange = function handleChange(event, itemValue) {
    var oldValues = input.value || [];

    var newValues = _lodash["default"].without(oldValues, itemValue);

    if (event.target.checked) {
      newValues = oldValues.concat(itemValue);
    }

    input.onChange(newValues);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_FieldLabel["default"], {
    field: checkboxGroup,
    isRequired: isRequired
  }), checkboxGroup.items && checkboxGroup.items.map(function (item) {
    return /*#__PURE__*/React.createElement("label", {
      key: item.key,
      htmlFor: "".concat(input.name, ".").concat(item.key),
      className: item.classes || inputStyle.controlClass
    }, /*#__PURE__*/React.createElement("input", {
      checked: input.value && input.value.indexOf(item.value) >= 0,
      disabled: disabled,
      id: "".concat(input.name, ".").concat(item.key),
      onChange: function onChange(e) {
        return handleChange(e, item.value);
      },
      type: "checkbox",
      className: inputStyle.indicatorClass
    }), /*#__PURE__*/React.createElement("span", null, item.label || item.value || item.key));
  }));
};

exports.CheckboxGroup = CheckboxGroup;
CheckboxGroup.defaultProps = {
  disabled: false
};

var RFCheckboxGroup = function RFCheckboxGroup(_arg2) {
  var checkboxGroup = _arg2.checkboxGroup,
      disabled = _arg2.disabled,
      inheritedFieldValidation = _arg2.inheritedFieldValidation,
      onChange = _arg2.onChange;
  return /*#__PURE__*/React.createElement(_FormFieldWrapper["default"], {
    field: checkboxGroup,
    renderField: function renderField(_ref) {
      var input = _ref.input,
          inputStyle = _ref.inputStyle,
          isRequired = _ref.isRequired;
      return /*#__PURE__*/React.createElement(CheckboxGroup, {
        checkboxGroup: checkboxGroup,
        disabled: disabled,
        input: input,
        inputStyle: inputStyle,
        isRequired: isRequired
      });
    },
    inheritedFieldValidation: inheritedFieldValidation,
    onChange: onChange
  });
};

RFCheckboxGroup.defaultProps = {
  disabled: false,
  inheritedFieldValidation: [],
  onChange: undefined
};
var _default = RFCheckboxGroup;
exports["default"] = _default;